<template>
  <el-dialog
    custom-class="dailogComponents"
    :title="title"
    :visible.sync="visible"
    :destroy-on-close="true"
    :width="width + 'px'"
    :close-on-click-modal = 'false'
  >
  <div class="dailogContext">
    <p v-if="context">{{ context }}</p>
    <p v-if="htmlContext" v-html="htmlContext"></p>
  </div>
    <el-row type="flex" class="dailogButBox dailogRomoveBox" justify="center">
      <el-col :span="6">
        <el-button size="medium" @click="close">取消</el-button>
      </el-col>
      <el-col :span="6"></el-col>
      <el-col :span="6">
        <el-button size="medium" type="primary" @click="submit">{{okButText}}</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      title: "删除",
      context: null,
      htmlContext: null,
      callbackFun: null,
      width: 300,
      okButText:'确认',
    };
  },
  methods: {
    close() {
      this.visible = false;
    },
    submit() {
      this.callbackFun();
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.dailogComponents {
  .dailogContext {
    text-align: center;
    margin: 20px 0px;
    line-height: 200%;
    padding: 0px 10px;
  }
  .dailogButBox {
    padding-top: 10px;
    border-top: 1px solid #dcdfe6;
  }
  .dailogRomoveBox{
    padding-bottom: 10px;
  }
  .el-dialog__body {
    padding: 10px 0px 0px 0px !important;
    border-top: 1px solid #dcdfe6;
  }
}
</style>

